export const HAMBURG_GEOJSON = require('./hamburg.json');
